<style>
    .btn-action-login  {
        cursor: pointer;
        border-bottom: 1px solid #ffffff;
        padding: 15px;
    }

    .btn-action-login-last  {
        cursor: pointer;
        padding: 15px;
    }
</style>

<template>
    <div class="animated fadeIn v-login">
        <div :style="{'background-image': 'url(' + Core.Session.Setting.getSetting('environment.ui.login.bgImage', '', Core.Value.typeImage) + ')'}" class="app flex-row align-items-center">
            <div class="container">
                <b-row class="justify-content-center">
                    <b-col md="8">

                        <Request
                                ref="login"
                                method="GET"
                                :options="{ blockOnProcessing: false, showAlert: false }"
                                :onRequestSuccess="requestLoginSuccess"
                                :onRequestError="requestLoginError"
                                root="/session">
                            <slot slot="body">
                                <b-card-group >
                                    <b-card no-body class="p-3 bg-login" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.primaryBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.primaryBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.primaryTextColor', '', Core.Value.typeColor)}">
                                        <b-card-body>
                                            <b-form v-on:submit.prevent="login">
                                                <div>
                                                    <img class="mb-4" :width="Core.Session.Setting.getSetting('environment.ui.login.logoWidth', '200px')"
                                                         :src="Core.Session.Setting.getSetting('environment.ui.login.logo', Core.Session.Setting.getSetting('environment.ui.logoFull'))">
                                                </div>
                                                <p :style="{ 'color': Core.Session.Setting.getSetting('environment.ui.login.primaryTextColor', '', Core.Value.typeColor)}">
                                                    {{Core.Definition.getDefinition('Connectez-vous à votre compte')}}</p>
                                                <b-input-group class="mb-3">
                                                    <b-input-group-prepend>
                                                        <b-input-group-text><i class="fa fa-user"></i>
                                                        </b-input-group-text>
                                                    </b-input-group-prepend>
                                                    <b-form-input v-on:keyup.enter="login" v-model="dataUser" type="text" class="form-control"
                                                                  :placeholder="Core.Definition.getDefinition('Utilisateur')"
                                                                  autocomplete="username email"/>
                                                </b-input-group>
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-input-group-text><i class="fa fa-lock"></i>
                                                        </b-input-group-text>
                                                    </b-input-group-prepend>
                                                    <b-form-input v-on:keyup.enter="login" type="password" v-model="dataPassword" class="form-control"
                                                                  :placeholder="Core.Definition.getDefinition('Mot de passe')"
                                                                  autocomplete="current-password"/>
                                                </b-input-group>
                                                <div class="text-right">
                                                  <b-button @click="passwordRecovery" variant="link" :style="{ 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor)}"  class="px-0 mb-2 fa-user-">
                                                    {{Core.Definition.getDefinition('Mot de passe oublié?')}}
                                                  </b-button>
                                                </div>
                                                <Alert :alert="dataAlert"></Alert>
                                                <b-row>
                                                    <b-col cols="12">
                                                        <b-button type="button" :disabled="dataProcessing" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.loginButtonTextColor', '', Core.Value.typeColor)}" @click="login" class="px-4">
                                                            <i v-if="dataProcessing" class="fa fa-spin fa-spinner mr-1"></i>{{Core.Definition.getDefinition('Connexion')}}
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-form>
                                        </b-card-body>
                                    </b-card>
                                    <b-card v-if="Core.Session.isSubEnvironment() === true" no-body class="py-5" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.secondaryBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.secondaryBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.secondaryTextColor', '', Core.Value.typeColor)}">
                                        <div @click="userRegister" class="mt-4 btn-action-login">
                                            <i class="fa fa-user p-3 font-2xl mr-3 float-left"></i>
                                            <div class="h5 mb-0 mt-2">{{Core.Definition.getDefinition('Nouveau client')}}</div>
                                            <small class="text-uppercase font-weight-bold font-xs">{{Core.Definition.getDefinition('Créez un compte client')}}</small>
                                        </div>
                                        <div @click="calendar" class="btn-action-login">
                                            <i class="fa fa-calendar p-3 font-2xl mr-3 float-left"></i>
                                            <div class="h5 mb-0 mt-2">{{Core.Definition.getDefinition('Calendrier')}}</div>
                                            <small class="text-uppercase font-weight-bold font-xs">{{Core.Definition.getDefinition('Réserver en ligne')}}</small>
                                        </div>
                                        <div @click="shop" class="btn-action-login-last">
                                            <i class="fa fa-shopping-cart p-3 font-2xl mr-3 float-left"></i>
                                            <div class="h5 mb-0 mt-2">{{Core.Definition.getDefinition('Boutique')}}</div>
                                            <small class="text-uppercase font-weight-bold font-xs">{{Core.Definition.getDefinition('Magasinez en ligne')}}</small>
                                        </div>
                                    </b-card>
                                    <b-card v-else no-body class="py-5" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.secondaryBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.secondaryBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.secondaryTextColor', '', Core.Value.typeColor)}" >
                                        <b-card-body class="text-center">
                                            <div>
                                                <h2 :style="{ 'color':  Core.Session.Setting.getSetting('environment.ui.login.secondaryTextColor', '', Core.Value.typeColor)}">{{Core.Definition.getDefinition('Entreprise')}}</h2>
                                                <p :style="{ 'color':  Core.Session.Setting.getSetting('environment.ui.login.secondaryTextColor', '', Core.Value.typeColor)}">
                                                    {{Core.Definition.getDefinition('Vous possédez une entreprise? Optez pour Perfoplanning et créez un compte entreprise dès maintenant!')}}
                                                </p>
                                                <b-button type="button" @click="environmentRegister" :style="{ 'background-color':  Core.Session.Setting.getSetting('environment.ui.login.registerButtonBGColor', '', Core.Value.typeColor) , 'border-color':  Core.Session.Setting.getSetting('environment.ui.login.registerButtonBorderColor', '', Core.Value.typeColor), 'color':  Core.Session.Setting.getSetting('environment.ui.login.registerButtonTextColor', '', Core.Value.typeColor)}" class="active mt-3">
                                                    {{Core.Definition.getDefinition('Créer un compte entreprise')}}
                                                </b-button>
                                            </div>
                                        </b-card-body>
                                    </b-card>
                                </b-card-group>
                            </slot>
                        </Request>

                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Request from '../../components/Request'
    import Alert from '../../components/Alert'
    import CryptoJS from 'crypto-js'
    export default {
        name: 'Login',
        components: {
            Request,
            Alert
        },
        mounted() {
            if (Core.Session.AuthUser.isAuth()) {
                this.$router.push(Core.Definition.getDefinition('/tableau-de-bord'))
            }
        },
        data: function () {
            return {
                Core: window.Core,
                dataProcessing: false,
                dataUser: '',
                dataPassword: '',
                dataAlert: {}
            }
        },
        methods: {
            login() {
                this.dataProcessing = true
                this.dataAlert.show = false
                let password = CryptoJS.MD5(this.dataPassword).toString()
                this.$refs.login.addArg('user', this.dataUser)
                this.$refs.login.addArg('password', password)
                this.$refs.login.addArg('login', '1')
                this.$refs.login.request()
            },
            requestLoginSuccess(data) {

                if (Core.Session.environment.status !== undefined) {
                    switch(Core.Session.environment.status) {
                        case Core.Environment.statusMaintenance:
                            this.$router.push(Core.Definition.getDefinition('/maintenance'))
                            break
                    }
                }

                if (data.alert !== undefined) {
                    this.dataAlert = data.alert
                } else {
                    if(Core.Session.AuthUser.can('event_booking')) {
                        this.$router.push(Core.Definition.getDefinition('/evenement/reserver'))
                    } else {
                        this.$router.push(Core.Definition.getDefinition('/tableau-de-bord'))
                    }
                }

                this.dataProcessing = false
            },
            requestLoginError(data) {
            },
            passwordRecovery() {
                this.$router.push(Core.Definition.getDefinition('/recuperation-mot-de-passe'))
            },
            environmentRegister() {
                this.$router.push(Core.Definition.getDefinition('/creation/environnement'))
            },
            userRegister() {
                this.$router.push(Core.Definition.getDefinition('/inscription'))
            },
            shop() {
                this.$router.push(Core.Definition.getDefinition('/commerce/boutique'))
            },
            calendar() {
                this.$router.push(Core.Definition.getDefinition('/evenement/reserver'))
            }
        }
    }
</script>
